export enum GlobalText {
	VariationHigh = "CB928433-388E-44EC-B40F-BFFED67A6FD0",
	VariationMedium = "AA27B4FA-4CAC-4F52-98E4-9762B5162718",
	VariationLow = "D97084C3-9D98-4DB5-AF83-05533E82FAD6",
}
